function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

import { actions } from "../../BasicReducer";
import { notificationActions } from "../../Notifications";
import { RequestParams } from "../../utils/RequestParams";


import Auth2faAPI from "../Auth2faAPI";







export function enable2fa() {
  return actions.setIn('auth/user', 'using2fa', true);
}

export function reset2fa(user) {
  return async (dispatch) => {
    await Auth2faAPI.reset2fa(new RequestParams({ _id: user._id }));
    dispatch(actions.update('users', _objectSpread(_objectSpread({}, user), {}, { using2fa: false })));
    dispatch(notificationActions.notify('Deleted successfully.', 'success'));
  };
}